import { render, staticRenderFns } from "./TaxLayout.vue?vue&type=template&id=4d1d319e&scoped=true&"
import script from "./TaxLayout.vue?vue&type=script&lang=js&"
export * from "./TaxLayout.vue?vue&type=script&lang=js&"
import style0 from "./TaxLayout.vue?vue&type=style&index=0&id=4d1d319e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d319e",
  null
  
)

component.options.__file = "TaxLayout.vue"
export default component.exports